export default {
  validation: "Dies ist ein Pflichtfeld",
  invalidDate: "Bitte geben Sie ein gültiges Datum ein.",
};
